import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Cookies from 'universal-cookie';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Alert } from 'react-bootstrap';
import { load, logoutUser, nextPath } from '../../../actions/authActions';
import { mfaLogin } from '../../../actions/mfaActions';
import { updateMe } from '../../../actions/userActions';
import config from '../../../config';
import EulaModal from '../../../components/Eula/EulaModal';
import MfaModal from '../../../components/Mfa/MfaModal';
import PasswordPrompt from '../../../components/Prompt/PasswordPrompt';
import { ssoLogin, ssoFetchIdps } from '../../../actions/ssoActions';
import './Login.css';
import SafeIframe from '../../../components/SafeIframe/SafeIframe';

// Use "globalThis" instead of "window", "self", or "global" (javascript:S7764)
const window = globalThis.window;
const cookies = new Cookies();

export class LoginPage extends Component {
  state = {
    user: {},
    userLogin: {
      clientname: cookies.get('clientname'),
      username: cookies.get('username'),
      remember: Boolean(cookies.get('remember')),
      password: '',
    },
    togglePassword: false,
    safeName: null,
    showWelcome: false,
    showWelcome_Greet: false,
    showWelcome_Success: false,
    loginPending: false,
    showMfa: false,
    showEula: false,
    showPass: false,
    seenEula: false,
    clientMfa: null,
    mfa_verified: null,
    isSAML: false,
  };

  // avoid setState after unmount when fetching IdPs
  mounted = false;

  showEulaIfNotAccepted = () => {
    if (this.state.loginPending) {
      this.setState({ loginPending: false });
    }

    const { user } = this.props;
    const { seenEula } = this.state;
    const { showWelcome } = this.state;

    if (!showWelcome && !seenEula && user && user.user?.sso_session_id) {
      const { firstname } = user.user;

      this.setState({ showWelcome_Greet: true, showWelcome: true, firstname, user: user.user });

      // Display EULA after Welcome has been displayed
      setTimeout(() => {
        this.setState({ seenEula: true });
        this.step3acceptEula();
      }, 5000);
    }
  };

  componentDidMount() {
    this.mounted = true;
    // Show new user greeting and EULA form if SSO user hasn't yet accepted
    this.showEulaIfNotAccepted();
    this.fetchIdps().then(idps => {
      if (this.mounted) {
        this.setState({ idps });
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  fetchIdps = async () => {
    try {
      const { idps } = await ssoFetchIdps();

      return idps;
    } catch (e) {
      console.log('SSO IdP Retrieval Error: Admin, please diagnose issue:', e);
    }
  };

  // ===========================================================================
  // SSO Related functions - start
  // ===========================================================================

  // Button click: SSO integration option
  step1ssoLogin = async event => {
    event.preventDefault();
    event.stopPropagation();

    const { loginPending } = this.state;

    if (loginPending) {
      return;
    }

    const button = event.target.closest('button');
    const idp = Number.parseInt(button.dataset.idpId, 10);

    this.setState({
      idp,
      isSAML: true,
      loginError: false,
    });
  };

  // Button click: Contiue to IdP SSO sign-in page
  step2ssoLogin = async event => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ loginError: false, loginErrorSSO: false, loginPending: true });
    const { idp } = this.state;
    const { location } = this.props;
    let redirectPath = null;

    if (location?.state) {
      const {
        state: { hash, pathname, search },
      } = location;

      redirectPath = `${pathname}${hash}${search}`;
    }

    const { clientname: client } = this.getCredentials();

    try {
      const res = await ssoLogin(client, idp, redirectPath);
      const { url } = res;

      window.location.href = url;
    } catch (e) {
      console.error('step2ssoLogin error captured', e);

      return this.showErrorSSO();
    }
  };

  // Button click: Back to standard login
  step2ssoCancel = async event => {
    event.preventDefault();
    event.stopPropagation();

    const { idp, ...state } = this.state;

    this.setState({ ...state, loginErrorSSO: false, isSAML: false });
  };

  // ===========================================================================
  // SSO Related functions - end
  // ===========================================================================

  onChange = event => {
    const { userLogin } = this.state;
    const { name, value, checked } = event.target;

    userLogin[name] = name === 'remember' ? checked : value;
    this.setState({ userLogin });
  };

  onSuccessMfa = user => this.setState({ user }, this.step3acceptEula);

  showError = () => this.setState({ loginPending: false, loginError: true });

  showErrorSSO = () => this.setState({ loginPending: false, loginErrorSSO: true });

  hideMfa = () => this.setState({ showMfa: false });

  getCredentials = () => {
    const { clientname, username, password } = this.state.userLogin;

    return { clientname, username, password };
  };

  eulaDisagree = () => {
    logoutUser();
    this.setState({ showEula: false, showWelcome: false });
  };

  eulaAgree = async () => {
    const { user } = this.state;
    const isSSO = Boolean(user.sso_session_id);

    user.eula_accepted = config.app.eulaVersion;
    this.setState({ showEula: false });

    try {
      await updateMe(user);
    } catch (e) {
      console.error('eulaAgree error captured', e);
      this.setState({ loginError: e.error });

      return this.showError();
    }

    if (isSSO) {
      this.setState({ showWelcome_Greet: false, showWelcome_Success: true });
      setTimeout(() => {
        window.location.reload();
      }, 5000);

      return;
    }

    if (!user.promptPasswordChange) {
      return this.step5setCookies();
    }

    this.step4changePass();
  };

  step1basicLogin = async event => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ loginError: false, loginPending: true });

    let res;

    try {
      res = await mfaLogin(this.getCredentials());
    } catch (e) {
      console.error('step1basicLogin error captured', e);

      return this.showError();
    }

    this.setState({ loginPending: false });
    const { user, clientMfa, mfa_verified } = res;

    // user logged in using basic auth
    if (user) {
      this.setState({ user });

      return this.step3acceptEula();
    }

    // user must login using 2FA
    this.setState({ clientMfa, mfa_verified });
    this.step2tokenLogin();
  };

  step2tokenLogin = () => this.setState({ showMfa: true, showEula: false, showPass: false });

  step3acceptEula = () => {
    const { eula_accepted, sso_session_id: isSSO } = this.state.user;
    const { eulaVersion } = config.app;

    // user must accept EULA
    if (!eula_accepted || eula_accepted < eulaVersion) {
      return this.setState({ showMfa: false, showEula: true, showPass: false });
    }

    // If this is an SSO login then skip password change
    if (!isSSO) {
      this.step4changePass();
    }
  };

  step4changePass = () => {
    const { promptPasswordChange } = this.state.user;

    if (promptPasswordChange) {
      return this.setState({ showMfa: false, showEula: false, showPass: true });
    }

    this.step5setCookies();
  };

  step5setCookies = () => {
    const { clientname, username, remember } = this.state.userLogin;
    const options = { secure: globalThis.location?.protocol === 'https:', maxAge: 31536000 }; // 1 year

    if (remember) {
      cookies.set('clientname', clientname, options);
      cookies.set('username', username, options);
      cookies.set('remember', remember, options);
    } else {
      cookies.remove('clientname');
      cookies.remove('username');
      cookies.remove('remember');
    }

    this.step6redirect();
  };

  step6redirect = this.props.load;

  render() {
    const {
      userLogin: { clientname, username, password, remember },
      firstname,
      loginError,
      loginErrorSSO,
      loginPending,
      showWelcome,
      showWelcome_Greet,
      showWelcome_Success,
      showMfa,
      showEula,
      showPass,
      mfa_verified,
      clientMfa,
      isSAML,
      idps,
      idp: selectedIdp,
      togglePassword,
    } = this.state;
    const {
      constants: { login_page_iframe },
    } = this.props;
    const isIdpEnabled = Array.isArray(idps) && idps.length > 0;

    return (
      <div className="flex flex-col justify-center items-center w-screen h-screen bg-[linear-gradient(135deg,_#f26722_0%,_#f2695d_48%,_#f0463c_100%)]">
        <Helmet title="Login" />
        {showWelcome && (
          <div className="sso-welcome">
            {showWelcome_Greet && (
              <div className="greet">
                <h1>Hi {firstname}, Welcome to SignStix!</h1>
              </div>
            )}
            {showWelcome_Success && (
              <div className="welcome">
                <h1>Thank you, {firstname}!</h1>
              </div>
            )}
          </div>
        )}
        <div
          className=" md:w-[832px]  w-[370px] bg-gradient-to-br from-white/5
           to-white/50 backdrop-blur-lg border border-white/20 shadow-xl rounded-3xl p-6 flex justify-between items-center"
        >
          <div
            id="iframe-container"
            className="w-[365px] h-full bg-white rounded-lg flex flex-col items-center th-hidden md:!flex self-center overflow-hidden"
          >
            <SafeIframe
              dataTest="login-iframe"
              src={login_page_iframe}
              className="h-full w-full"
              title="Welcome Page"
            />
          </div>
          <div
            id="form-container"
            className="w-[365px] bg-transparent rounded-lg flex flex-col items-center self-center"
          >
            <img
              className="w-[302px] h-[86px] "
              data-test="logo"
              alt="logo"
              src="/assets/images/logo/signstix_white_signin_logo.svg"
            />
            <form className="login-form form-inline !m-0" method="POST">
              {loginErrorSSO && (
                <Alert data-test="warning" bsStyle="danger">
                  <b>Login failed</b>
                  <p>Please check the following:</p>
                  <ul>
                    <li>Your client name is correct</li>
                    <li>Your company supports SSO (single sign-on)</li>
                  </ul>
                </Alert>
              )}
              {loginError && (
                <Alert data-test="warning" bsStyle="danger">
                  <b>Login failed</b>
                  <p>Please check your client name, username and password and try again</p>
                </Alert>
              )}
              <Grid fluid style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                <Row>
                  <Col md={12}>
                    <div className="w-[313px] h-[50px] rounded-3xl border-white border-[2px] mt-6 flex items-center pl-2">
                      <p className="font-[700] poppins-bold  mb-0  w-[110px] pl-[12px]">Account:</p>
                      <div className="w-[1px] h-full bg-white " />
                      <input
                        data-test="input-clientname"
                        name="clientname"
                        placeholder="Client Name"
                        type="text"
                        id="login-clientname"
                        className="bg-transparent border-0 outline-none ml-2 w-[205px]  h-full text-[#00243E] placeholder-[#00243E] no-autofill-bg"
                        autoFocus
                        onChange={this.onChange}
                        defaultValue={clientname}
                      />
                    </div>
                  </Col>
                </Row>
                {!isSAML && (
                  <>
                    <Row>
                      <Col md={12}>
                        <div className="w-[313px] h-[50px] rounded-3xl border-white border-[2px] mt-6 flex items-center pl-2">
                          <p className="font-[700] poppins-bold  mb-0  w-[110px] pl-[12px]">
                            User:
                          </p>
                          <div className="w-[1px] h-full bg-white " />
                          <input
                            data-test="input-username"
                            name="username"
                            placeholder="Username"
                            type="text"
                            id="login-username"
                            className="bg-transparent border-0 outline-none ml-2  w-[205px] h-full text-[#00243E] placeholder-[#00243E] no-autofill-bg"
                            onChange={this.onChange}
                            defaultValue={username}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className="w-[313px] h-[50px] rounded-3xl border-white border-[2px] mt-6 flex items-center pl-2">
                          <p className="font-[700] mb-0  poppins-bold w-[110px] pl-[12px]">
                            Password:
                          </p>

                          <div className="w-[1px]  h-full bg-white " />
                          <input
                            data-test="input-password"
                            name="password"
                            placeholder="Password"
                            type={togglePassword ? 'text' : 'password'}
                            id="login-password"
                            className="bg-transparent border-0 outline-none ml-2 w-[172px]  h-full text-[#00243E] placeholder-[#00243E] no-autofill-bg"
                            onChange={this.onChange}
                            defaultValue={password}
                          />

                          <button
                            type="button"
                            className=" flex justify-center items-center w-[30px] "
                            onClick={() => this.setState({ togglePassword: !togglePassword })}
                          >
                            {togglePassword ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-eye"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-eye-off"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" />
                                <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" />
                                <path d="M3 3l18 18" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <div className=" mt-2 ml-[2px]">
                          <input
                            data-test="checkbox-remember"
                            name="remember"
                            type="checkbox"
                            checked={remember}
                            onChange={this.onChange}
                            className="mt-2"
                          />
                          <span
                            className="text-[#00243E] ml-2 poppins-regular mt-2 text-[12px]"
                            style={{
                              fontSize: '12px',
                              position: 'relative',
                              top: '-2px',
                              left: '-4px',
                              userSelect: 'none',
                            }}
                          >
                            Remember me
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <button
                          disabled={Boolean(loginPending)}
                          data-test="button-submit"
                          type="submit"
                          className="mt-4 w-[313px] h-[50px] bg-[#00243E] poppins-bold rounded-lg text-white font-[700] duration-500  active:bg-[#00243E] hover:scale-105"
                          onClick={this.step1basicLogin}
                        >
                          {loginPending ? 'Please wait...' : 'Log In'}
                        </button>
                      </Col>
                    </Row>
                    {isIdpEnabled && (
                      <>
                        {idps.map(idp => {
                          return (
                            <Row key={idp.id}>
                              <Col md={12}>
                                <div className="form-group" style={{ marginTop: '10px' }}>
                                  <button
                                    data-idp-id={idp.id}
                                    data-test={`button-${idp.tag}`}
                                    type="submit"
                                    className="w-[313px] h-[50px] bg-[#00243E] poppins-bold rounded-lg text-white font-[700] duration-500   active:bg-[#00243E] hover:scale-105 flex justify-center items-center space-x-2"
                                    onClick={this.step1ssoLogin}
                                    style={{ textAlign: 'center' }}
                                  >
                                    <img
                                      alt={idp.tag}
                                      height={18}
                                      width={18}
                                      src={`/assets/images/misc/integrations/${idp.tag}/logo.svg`}
                                    />
                                    <span className="text-inherit">Log In with {idp.name}</span>
                                  </button>
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                      </>
                    )}
                  </>
                )}
                {isSAML && (
                  <>
                    <Row style={{ marginTop: '20px' }}>
                      <Col md={12}>
                        <button
                          disabled={Boolean(loginPending)}
                          data-test="button-entra"
                          type="submit"
                          className="mt-4 w-[313px] h-[50px] bg-[#00243E] poppins-bold rounded-lg text-white font-[700] duration-500 hover:bg-white hover:text-[#00243E] active:bg-[#00243E] hover:scale-105"
                          onClick={this.step2ssoLogin}
                        >
                          <div style={{ marginTop: '-5px' }}>
                            <i
                              style={{ marginRight: '5px' }}
                              className="material-icons inline color-white"
                            >
                              input
                            </i>
                            <span>
                              {loginPending
                                ? 'Please wait...'
                                : `Continue to ${idps.find(idp => idp.id === selectedIdp).name}`}
                            </span>
                          </div>
                        </button>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <button
                          data-test="button-entra"
                          type="submit"
                          className="mt-4 w-[313px] h-[50px] bg-[#00243E] poppins-bold rounded-lg text-white font-[700] duration-500 hover:bg-white hover:text-[#00243E] active:bg-[#00243E] hover:scale-105"
                          onClick={this.step2ssoCancel}
                        >
                          <div style={{ marginTop: '-5px' }}>
                            <i
                              style={{ marginRight: '5px' }}
                              className="material-icons inline color-white"
                            >
                              arrow_back
                            </i>
                            <span>Back to Standard Login</span>
                          </div>
                        </button>
                      </Col>
                    </Row>
                  </>
                )}
              </Grid>
            </form>
          </div>
          <MfaModal
            show={showMfa}
            credentials={this.getCredentials()}
            clientMfa={clientMfa}
            verified={mfa_verified}
            onHide={this.hideMfa}
            onSuccess={this.onSuccessMfa}
          />
          <EulaModal
            show={showEula}
            onHide={this.eulaDisagree}
            onSuccess={this.eulaAgree}
            version={config.app.eulaVersion}
          />
          <PasswordPrompt show={showPass} onSuccess={this.step5setCookies} />
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  user: PropTypes.object,
  nextPath: PropTypes.func,
  load: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  constants: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    constants: state.constants.data,
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      nextPath,
      load,
    },
    dispatch,
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPage));
